import {Component} from '@angular/core';
import {ProductResourceTileComponent} from '../product-resource-tile/product-resource-tile.component';

@Component({
  selector: 'dcp-product-single-resource-tile',
  templateUrl: './product-single-resource-tile.component.html',
  styleUrls: ['./product-single-resource-tile.component.scss']
})
export class ProductSingleResourceTileComponent extends ProductResourceTileComponent {

  constructor() {
    super();
  }
}
